import { render, staticRenderFns } from "./LeadDeletion.vue?vue&type=template&id=22fcb7fa"
import script from "./LeadDeletion.vue?vue&type=script&lang=js"
export * from "./LeadDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports